import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
  title: "",
  text: "",
  icon: "",
  autoWidth: false,
  primaryButtonTitle: "",
  primaryButtonOnClick: () => {},
  primaryButtonDisabled: false,
  secondaryButtonTitle: "Cancel",
  secondaryButtonOnClick: () => {},
  disableClose: false,
  extraContent: null,
  extraButtonTitle: "",
  extraButtonOnClick: () => {},
};

const dialogPopupSlice = createSlice({
  name: "dialogPopup",
  initialState,
  reducers: {
    openDialogPopup: (state, action) => {
      state.isOpen = action.payload.isOpen;
      state.disableClose = action.payload.disableClose;
      state.title = action.payload.title;
      state.text = action.payload.text;
      state.icon = action.payload.icon;
      state.primaryButtonTitle = action.payload.primaryButtonTitle;
      state.primaryButtonOnClick = action.payload.primaryButtonOnClick;
      state.primaryButtonDisabled = action.payload.primaryButtonDisabled;
      state.secondaryButtonTitle = action.payload.secondaryButtonTitle;
      state.secondaryButtonOnClick = action.payload.secondaryButtonOnClick;
      state.extraContent = action.payload.extraContent;
      state.extraButtonTitle = action.payload.extraButtonTitle;
      state.extraButtonOnClick = action.payload.extraButtonOnClick;
      state.autoWidth = action.payload.autoWidth;
    },
    closeDialogPopup: (state) => {
      // state=initialState;
      Object.assign(state, initialState);
    },
    setPrimaryButtonDisabled: (state, action) => {
      state.primaryButtonDisabled = action.payload;
    },
  },
});

export const { openDialogPopup, closeDialogPopup, setPrimaryButtonDisabled } =
  dialogPopupSlice.actions;
export default dialogPopupSlice.reducer;
